import DeleteModal from './DeleteModal.component';

export default DeleteModal;
